import React from "react";

// Stylised SVG product placeholders, keyed by `kind`.
// All visuals have been switched to mobile-accessory themes while keeping
// the same component API.

export const ProductVisual = ({ kind }) => {
    if (kind === "case" || kind === "turbine") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="caseBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="#c2c6cc" />
                    </linearGradient>
                </defs>
                <rect
                    x="70"
                    y="20"
                    width="180"
                    height="180"
                    rx="28"
                    fill="url(#caseBody)"
                    stroke="#9aa0aa"
                    strokeWidth="0.5"
                />
                <rect x="85" y="40" width="150" height="140" rx="20" fill="#0b0b0d" />
                <rect x="170" y="30" width="50" height="14" rx="7" fill="#1c1c1e" />
                <circle cx="185" cy="37" r="4" fill="#333" />
                <circle cx="205" cy="37" r="4" fill="#333" />
                <rect x="75" y="90" width="6" height="40" rx="3" fill="#8b5cf6" opacity="0.8" />
            </svg>
        );
    }
    if (kind === "cable" || kind === "contra") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="cableBody" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#e9eaee" />
                        <stop offset="100%" stopColor="#9aa0aa" />
                    </linearGradient>
                </defs>
                <path
                    d="M30 60 L70 60 C 100 60, 100 160, 130 160 L 250 160 C 280 160, 280 80, 310 80"
                    fill="none"
                    stroke="url(#cableBody)"
                    strokeWidth="14"
                    strokeLinecap="round"
                />
                <path
                    d="M30 60 L70 60 C 100 60, 100 160, 130 160 L 250 160 C 280 160, 280 80, 310 80"
                    fill="none"
                    stroke="#8b5cf6"
                    strokeWidth="3"
                    strokeLinecap="round"
                    opacity="0.6"
                />
                <rect x="10" y="45" width="40" height="30" rx="6" fill="#d1d1d6" stroke="#9aa0aa" strokeWidth="0.4" />
                <rect x="270" y="65" width="40" height="30" rx="6" fill="#d1d1d6" stroke="#9aa0aa" strokeWidth="0.4" />
            </svg>
        );
    }
    if (kind === "charger" || kind === "endo") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="chargerBody" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="#c2c6cc" />
                    </linearGradient>
                </defs>
                <rect x="80" y="50" width="120" height="120" rx="16" fill="url(#chargerBody)" stroke="#9aa0aa" strokeWidth="0.5" />
                <rect x="100" y="70" width="80" height="60" rx="8" fill="#0b0b0d" />
                <rect x="110" y="145" width="60" height="10" rx="5" fill="#8b5cf6" />
                <rect x="210" y="90" width="60" height="40" rx="6" fill="url(#chargerBody)" stroke="#9aa0aa" strokeWidth="0.5" />
                <rect x="265" y="100" width="15" height="20" rx="3" fill="#1c1c1e" />
            </svg>
        );
    }
    if (kind === "power" || kind === "implant") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="powerBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#1c1c1e" />
                        <stop offset="100%" stopColor="#2c2c2e" />
                    </linearGradient>
                </defs>
                <rect x="70" y="40" width="180" height="140" rx="18" fill="url(#powerBody)" />
                <rect x="90" y="70" width="140" height="70" rx="8" fill="#0b0b0d" />
                <text x="160" y="112" textAnchor="middle" fontSize="14" fontFamily="JetBrains Mono" fill="#8b5cf6">
                    20 000 mAh
                </text>
                <g fill="#8b5cf6">
                    <rect x="100" y="155" width="24" height="8" rx="4" />
                    <rect x="130" y="155" width="24" height="8" rx="4" opacity="0.6" />
                    <rect x="160" y="155" width="24" height="8" rx="4" opacity="0.6" />
                    <rect x="190" y="155" width="24" height="8" rx="4" opacity="0.6" />
                </g>
            </svg>
        );
    }
    if (kind === "audio" || kind === "torque") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="budsBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" />
                        <stop offset="100%" stopColor="#c2c6cc" />
                    </linearGradient>
                </defs>
                <rect x="90" y="40" width="140" height="100" rx="20" fill="url(#budsBody)" stroke="#9aa0aa" strokeWidth="0.5" />
                <rect x="105" y="55" width="110" height="70" rx="14" fill="#0b0b0d" />
                <ellipse cx="130" cy="160" rx="18" ry="28" fill="url(#budsBody)" stroke="#9aa0aa" strokeWidth="0.5" />
                <ellipse cx="190" cy="160" rx="18" ry="28" fill="url(#budsBody)" stroke="#9aa0aa" strokeWidth="0.5" />
                <circle cx="130" cy="160" r="6" fill="#8b5cf6" />
                <circle cx="190" cy="160" r="6" fill="#8b5cf6" />
            </svg>
        );
    }
    if (kind === "protection" || kind === "burs") {
        return (
            <svg viewBox="0 0 320 220" className="w-full h-full">
                <defs>
                    <linearGradient id="glassBody" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9" />
                        <stop offset="100%" stopColor="#bfeaff" stopOpacity="0.4" />
                    </linearGradient>
                </defs>
                <rect x="60" y="30" width="200" height="160" rx="20" fill="#f2f3f5" stroke="#d1d1d6" strokeWidth="0.6" />
                <rect x="70" y="40" width="180" height="140" rx="16" fill="url(#glassBody)" stroke="#8b5cf6" strokeWidth="0.8" />
                <line x1="70" y1="40" x2="250" y2="180" stroke="#ffffff" strokeWidth="1" opacity="0.6" />
                <line x1="70" y1="180" x2="250" y2="40" stroke="#ffffff" strokeWidth="1" opacity="0.6" />
            </svg>
        );
    }
    return (
        <svg viewBox="0 0 320 220" className="w-full h-full">
            <defs>
                <linearGradient id="genericBody" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#ffffff" />
                    <stop offset="100%" stopColor="#c2c6cc" />
                </linearGradient>
            </defs>
            <rect x="100" y="30" width="120" height="160" rx="20" fill="url(#genericBody)" stroke="#9aa0aa" strokeWidth="0.5" />
            <rect x="112" y="48" width="96" height="120" rx="12" fill="#0b0b0d" />
            <circle cx="160" cy="150" r="6" fill="#8b5cf6" />
        </svg>
    );
};

export default ProductVisual;
